// extracted by mini-css-extract-plugin
module.exports = {"container":"sc","hide":"sd","content":"se","close":"sf","closeIcon":"sh","svgStyles":"si"};